

export default {
    computed: {
        getOrderStatus() {
            return [
                { value: "draft", label: this.$t('boss.purchase.draft',{defaultValue:'草稿'}) ,theme:'gray'},
                { value: "submited", label: this.$t('boss.purchase.submitted',{defaultValue:'已提交'}) ,theme:"primary" },
                { value: "approved", label: this.$t('boss.purchase.audited',{defaultValue:'已审核'}),theme:"success" },
                { value: "refused", label: this.$t('boss.purchase.rejected',{defaultValue:'已驳回'}) ,theme:"error"},
                { value: "canceled", label: this.$t('boss.purchase.cancelled',{defaultValue:'已取消'}), theme: 'warning' },
                { value: "closed", label: this.$t('boss.purchase.completed',{defaultValue:'已完成'})},
            ]
        },
        
        //采购单状态
        getPurchaseOrderStatus(){
            return [
                {
                    value: 'draft',
                    label: this.$t('boss.purchase.draft',{defaultValue:'草稿'}),
                    theme: 'darkgray',
                },
                {
                    value: 'submit',
                    label: this.$t('boss.purchase.submitted',{defaultValue:'已提交'}),
                    theme: 'primary',
                },
                {
                    value: 'auditing_pass',
                    label: this.$t('boss.purchase.approved',{defaultValue:'审核通过'}),
                    theme: 'success'
                },
                {
                    value: 'finished',
                    label: this.$t('boss.purchase.completed',{defaultValue:'已完成'}),
                    theme: '',
                },
                {
                    value: 'canceled',
                    label: this.$t('boss.purchase.cancelled',{defaultValue:'已取消'}),
                    theme: 'warning'
                },
                {
                    value: 'auditing_refused',
                    label: this.$t('boss.purchase.review_rejected',{defaultValue:'审核驳回'}),
                    theme: 'error'
                },
            ];
        },
    },
}